//@ts-check
import useExchangeUiStaticData from './useExchangeUiStaticData';

/** @param {import('@action-types/ecApp').AppDetails['hostApps']} products Array of product SAP codes */
const useLabeledProducts = (products) => {
  const exchangeUiQuery = useExchangeUiStaticData();
  const allProducts = exchangeUiQuery.data?.cloudApps?.hostApps;

  const labeledProducts = products?.map((product) => {
    const matchingProduct = allProducts?.find(({ id }) => id === product);
    return matchingProduct?.label || product;
  });

  return { labeledProducts, exchangeUiQuery };
};

export default useLabeledProducts;
